export default __webpack_public_path__ + "static/media/bike_image9.0b99edee.jfif";